import React, { useState } from "react";
import { Row, Col, Card, Spinner, Button } from "react-bootstrap";
import { TextField } from "@mui/material";
import axios from "axios";
import swal from "sweetalert2";
import { HeadingFour, MyDiv } from "../../Common/Components";
import PropTypes from "prop-types";
import "quill/dist/quill.snow.css";
import { useQuill } from "react-quilljs";
import { useEffect } from "react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


function FormOrderFeedback({ handleClose, feedbackData, orderId }) {
  const [btnLoading, setBtnLoading] = useState(false);
  const [data, setData] = useState(
    feedbackData || {
      feedback: "",
    }
  );

  const { quill, quillRef } = useQuill({
    theme: "snow",
    placeholder: "Enter order feedback here...",
    modules: {
      toolbar: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["clean"],
      ],
    },
  });

  useEffect(() => {
    if (quill) {
      // Set initial content
      quill.root.innerHTML = data.feedback || "";

      // Listen for changes
      quill.on("text-change", () => {
        setData((prev) => ({
          ...prev,
          feedback: quill.root.innerHTML,
        }));
      });
    }
  }, [quill]);

  useEffect(() => {
    if (quill && quill.root.innerHTML !== (data.feedback || "")) {
      quill.root.innerHTML = data.feedback || "";
    }
  }, [data.feedback, quill]);

  const handleFieldChange = event => {
    setData(data => ({
      ...data,
      [event.target.name]: event.target.value,
    }));
  };

  function submit(e) {
    e.preventDefault();

    setBtnLoading(true);
    const url = feedbackData
      ? API_BASE_URL + "update-order-feedback/" + feedbackData._id
      : API_BASE_URL + "add-order-feedback/" + orderId;
    const method = feedbackData ? "patch" : "post";
    
    axios({
      method,
      url,
      data,
      headers: { 
        "x-access-token": localStorage.getItem("token"), 
        Accept: "application/json", 
        "Content-Type": "application/json" 
      },
    })
      .then(res => {
        if (res.status === 200 || res.status === 201) {
          swal.fire({
            text: res.data?.message || "Feedback saved successfully",
            icon: "success",
            type: "success",
          });
          handleClose();
          setBtnLoading(false);
        }
      })
      .catch(error => {
        setBtnLoading(false);
        swal.fire({
          text: error.response?.data || "An error occurred",
          icon: "error",
          type: "error",
        });
      });
  }

  return (
    <MyDiv className="DrawerRight">
      <MyDiv className="grid-margin general-form stretch-card">
        <Card md={12}>
          <Card.Header>
            <HeadingFour className="card-title">
              {feedbackData ? "Edit" : "Add"} Feedback
            </HeadingFour>
          </Card.Header>
          <Card.Body>
            <MyDiv className="DrawerForm">
              <form onSubmit={e => submit(e)}>
                <Row className="DrawerFormField">
                  <Col md={12}>
                    <div style={{ marginTop: 16 }}>
                      <label
                        style={{
                          display: "block",
                          marginBottom: 8,
                          fontWeight: 500,
                        }}
                      >
                        Feedback <span style={{ color: "red" }}>*</span>
                      </label>

                      <div
                        ref={quillRef}
                        style={{
                          minHeight: "250px",
                        }}
                      />
                    </div>
                  </Col>
                  <Col md={12} className="text-end">
                    {btnLoading ? (
                      <Button variant="primary" disabled className="mt-4 w-100">
                        <span aria-live="polite" className="d-inline-flex align-items-center">
                          <Spinner as="span" animation="border" size="sm" aria-hidden="true" className="mx-2" />
                          <span className="visually-hidden">Loading...</span>
                        </span>
                      </Button>
                    ) : (
                      <button type="submit" className="FormBtn">
                        Submit
                      </button>
                    )}
                  </Col>
                </Row>
              </form>
            </MyDiv>
          </Card.Body>
        </Card>
      </MyDiv>
    </MyDiv>
  );
}

export default FormOrderFeedback;

FormOrderFeedback.propTypes = {
  handleClose: PropTypes.func.isRequired,
  feedbackData: PropTypes.object,
  orderId: PropTypes.any.isRequired,
};